export const cohortBuilderHeaderMessagesEn = {
  // Cohort Builder Breadcrumbs
  'projects.cohortBuilderPage.breadcrumbs.projects': 'Projects',
  'projects.cohortBuilderPage.breadcrumbs.cohorts': 'Cohorts',

  // Cohort Builder Actions
  'projects.cohortBuilderPage.header.processButton': 'Process cohort',
  'projects.cohortBuilderPage.header.saveButton': 'Save',
  'projects.cohortBuilderPage.header.showResearchAssistantButton': 'Use Research Assistant (beta)',
  'projects.cohortBuilderPage.header.hideResearchAssistantButton': 'Use cohort builder',
  'projects.cohortBuilderPage.header.saveAndProcessButtonDisabledTooltip':
    'Saving and processing is disabled because there are one or more errors that require your attention',
  'projects.cohortBuilderPage.header.saveButtonTooltip':
    'Saving is disabled because there are one or more errors that require your attention',
  'projects.cohortBuilderPage.header.processButtonTooltip':
    'Processing is disabled because there are one or more errors that require your attention',

  // Cohort Builder Page Tabs
  'projects.cohortBuilderPage.pageTabs.resultsTab': 'Results',
  'projects.cohortBuilderPage.pageTabs.definitionTab': 'Definition',
  'projects.cohortBuilderPage.pageTabs.historyTab': 'History',
  'projects.cohortBuilderPage.pageTabs.eventsTab': 'Events',
  'projects.cohortBuilderPage.pageTabs.conceptsTab': 'Concepts',
  'projects.cohortBuilderPage.pageTabs.datasetsTab': 'Datasets',

  // Process Cohort Definition Modal
  'projects.cohortBuilderPage.processCohortDefinitionModal.title': 'Process cohort',
  'projects.cohortBuilderPage.processCohortDefinitionModal.confirmTitle': 'Confirm process cohort',
  'projects.cohortBuilderPage.processCohortDefinitionModal.message1':
    'This action will save the cohort and queue it for processing.',
  'projects.cohortBuilderPage.processCohortDefinitionModal.message2':
    'The cohort status will be updated from {draft} to {processing}.',
  'projects.cohortBuilderPage.processCohortDefinitionModal.message3':
    'Once processing is complete, the status will be updated to {processed} and the subjects and results will be available.',
  'projects.cohortBuilderPage.processCohortDefinitionModal.draft': 'Draft',
  'projects.cohortBuilderPage.processCohortDefinitionModal.processing': 'Processing',
  'projects.cohortBuilderPage.processCohortDefinitionModal.processed': 'Processed',

  'projects.cohortBuilderPage.processCohortDefinitionModal.entrySaveButtonText': 'Process cohort',
  'projects.cohortBuilderPage.processCohortDefinitionModal.entryCancelButtonText':
    'Continue editing',

  'projects.cohortBuilderPage.processCohortDefinitionModal.retryBtn': 'Retry',
  'projects.cohortBuilderPage.processCohortDefinitionModal.returnBtn': 'Return to cohorts list',
  'projects.cohortBuilderPage.processCohortDefinitionModal.successTitle': 'Success',
  'projects.cohortBuilderPage.processCohortDefinitionModal.successText':
    '"{cohortName}" has been saved and processing was queued successfully.',
  'projects.cohortBuilderPage.processCohortDefinitionModal.appErrorTitle': 'Application Error',
  'projects.cohortBuilderPage.processCohortDefinitionModal.systemErrorTitle': 'System Error',
  'projects.cohortBuilderPage.processCohortDefinitionModal.errorStatus': 'Status code: {status}',
  'projects.cohortBuilderPage.processCohortDefinitionModal.errorStatusWithOrg':
    'Status code: {status}, orginal status: {originalStatus}',

  // Save Cohort Definition Modal
  'projects.cohortBuilderPage.saveCohortDefinitionModal.title': 'Save cohort',
  'projects.cohortBuilderPage.saveCohortDefinitionModal.confirmTitle': 'Confirm save cohort',
  'projects.cohortBuilderPage.saveCohortDefinitionModal.message1':
    'This action will clear all processed data associated with the cohort.',
  'projects.cohortBuilderPage.saveCohortDefinitionModal.message2':
    'The cohort status will be updated from {processed} to {draft}.',
  'projects.cohortBuilderPage.saveCohortDefinitionModal.processed': 'Processed',
  'projects.cohortBuilderPage.saveCohortDefinitionModal.draft': 'Draft',
  'projects.cohortBuilderPage.saveCohortDefinitionModal.final': 'Final',
  'projects.cohortBuilderPage.saveCohortDefinitionModal.savingTitle': 'In progress',
  'projects.cohortBuilderPage.saveCohortDefinitionModal.description4':
    'Please wait while the cohort saves.',
  'projects.cohortBuilderPage.saveCohortDefinitionModal.saveBtn': 'Save cohort',
  'projects.cohortBuilderPage.saveCohortDefinitionModal.retryBtn': 'Retry',
  'projects.cohortBuilderPage.saveCohortDefinitionModal.cancelBtn': 'Continue editing',
  'projects.cohortBuilderPage.saveCohortDefinitionModal.returnBtn': 'Return to cohorts list',
  'projects.cohortBuilderPage.saveCohortDefinitionModal.successTitle': 'Success',
  'projects.cohortBuilderPage.saveCohortDefinitionModal.successText':
    '"{cohortName}" was saved successfully.',
  'projects.cohortBuilderPage.saveCohortDefinitionModal.successMessageText':
    'This window will close automatically in {countDown} seconds.',
  'projects.cohortBuilderPage.saveCohortDefinitionModal.errorTitle': 'System Error',
  'projects.cohortBuilderPage.saveCohortDefinitionModal.errorMessage': 'Please try again later.',

  // Exit the cohort builder
  'projects.cohortBuilderPage.cohortExitModal.title': 'Exit cohort builder',
  'projects.cohortBuilderPage.cohortExitModal.confirmTitle': 'Confirm exit cohort builder',
  'projects.cohortBuilderPage.cohortExitModal.message1':
    'This action will discard all changes made since the cohort was last saved.',
  'projects.cohortBuilderPage.cohortExitModal.processBtn': 'Continue editing',
  'projects.cohortBuilderPage.cohortExitModal.cancelBtn': 'Exit cohort builder',
};
